import { useQueryClient } from '@tanstack/react-query'
import { keys as getIDBKeyValKeys, del as delIDBKeyVal } from 'idb-keyval'
import { Auth } from 'aws-amplify'
import { IDB_VALID_KEY_PREFIX } from '@/utils/persister'

export default function useSignOut() {
  const queryClient = useQueryClient()
  const signOut = async () => {
    // Clear the query cache
    queryClient.clear()
    // Delete each relevant TanStack Query entry from IndexedDB
    const allKeys = await getIDBKeyValKeys()
    const tanstackQueryKeys = allKeys.filter(
      (key) => typeof key === 'string' && key.startsWith(IDB_VALID_KEY_PREFIX),
    )
    await Promise.all(tanstackQueryKeys.map((key) => delIDBKeyVal(key)))

    Auth.signOut().catch(console.error)
  }

  return signOut
}
